import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_CAROUSEL_CITY_MATCH = defineFcm('psf_carousel_city_match')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
			},
		}),
	)
	.withDefault({
		enabled: false,
	})
	.toConfig({
		owner: 'squad-chameleon',
		scope: 'corgi-middle-end',
		context: 'PSF carousel city match',
		description:
			'Feature config for the PSF carousel city match experiment (location scoring of promoted petitions in the post-sign-flow carousel)',
		template: {
			enabled: false,
		},
	});
